'use client';

import { ELanguage } from '../Utils/constants.js';
import vi from './vi.json.js';

var VN_PHONE_NUMBER_REGEX = /(^[35789]{1}\d{8}$)|(^0[35789]{1}\d{8}$)/;
var I11L_LIMIT_NUMBER = /^[0-9]{15}/;
var I11L_PHONE_NUMBER_REGEX = /^\d[0-9]{6,14}$/;
var VN_DIALCODE = '+84';
var IMG_URL = 'https://images.vietnamworks.com/images/icons';
var t = function (text, language) {
    if (language === ELanguage.EN)
        return text;
    return vi[text];
};
/**
 * @Note place this function into onKeyPress Input, which you want to force it enter only number
 * */
var exceptKeys = new Set(['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Tab']);
var enterOnlyNumber = function (event) {
    var key = event.key;
    if (exceptKeys.has(key))
        return;
    if (!/[0-9]/.test(key)) {
        event.preventDefault();
    }
};
var validateVietNamPhoneNumber = function (value) {
    return VN_PHONE_NUMBER_REGEX.test(value);
};
var validateI11lPhoneNumber = function (value) {
    return I11L_PHONE_NUMBER_REGEX.test(value);
};
var renderErrorMsg = function (language, phoneNumber, isVietNam) {
    if (!phoneNumber)
        return t('This field is required.', language);
    if (isVietNam && !validateVietNamPhoneNumber(phoneNumber)) {
        return t('The phone number format is invalid.', language);
    }
    if (!isVietNam && !validateI11lPhoneNumber(phoneNumber)) {
        return t('Accept 7 - 15 digits.', language);
    }
    return '';
};

export { I11L_LIMIT_NUMBER, I11L_PHONE_NUMBER_REGEX, IMG_URL, VN_DIALCODE, VN_PHONE_NUMBER_REGEX, enterOnlyNumber, renderErrorMsg, t, validateI11lPhoneNumber, validateVietNamPhoneNumber };
//# sourceMappingURL=helpers.js.map
